import { createRouter, createWebHistory } from 'vue-router'
import ProductList from '@/views/ProductList.vue'
import DictManagement from '@/views/DictManagement.vue'

const routes = [
  {
    path: '/',
    redirect: '/policies'
  },
  {
    path: '/policies',
    name: 'PolicyManagement',
    component: () => import('@/views/PolicyManagement.vue'),
    meta: {
      title: '政策管理'
    }
  },
  {
    path: '/products',
    name: 'ProductList',
    component: ProductList,
    meta: {
      title: '产品管理'
    }
  },

  {
    path: '/dicts',
    name: 'DictManagement',
    component: DictManagement,
    meta: {
      title: '字典管理'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - 贷款产品管理系统` : '贷款产品管理系统'
  next()
})

export default router 